import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronUpDownOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="m12 1 7 7-1.273 1.273L12 3.546 6.273 9.273 5 8zM5 16l1.273-1.273L12 20.454l5.727-5.727L19 16l-7 7z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ChevronUpDownOutlinedSize24Glyph.displayName = 'ChevronUpDownOutlinedSize24Glyph';
